import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-features",
  templateUrl: "./features.component.html",
  styleUrls: ["./features.component.scss"],
})
export class FeaturesComponent implements OnInit {
  @Input() arzyabi;

  features = [
    {
      title: "بررسی دقیق",
      text: "بیش از ۷۰۰ هزار نقطه ژنتیکی",
      icon: "./assets/img/theme/features/1.webp",
    },
    { title: "ارزیابی", text: "", icon: "./assets/img/theme/features/2.webp" },
    {
      title: "۲ جلسه",
      text: "مشاوره با متخصصان روانشناس",
      icon: "./assets/img/theme/features/3.webp",
    },
    {
      title: "هزینه ارسال کیت",
      text: "رایگان",
      icon: "./assets/img/theme/features/4.webp",
    },
    {
      title: "دفترچه ژنتیکی",
      text: "شخصی سازی شده",
      icon: "./assets/img/theme/features/5.webp",
    },
    {
      title: "عضویت",
      text: "در باشگاه مشتریان",
      icon: "./assets/img/theme/features/6.webp",
    },
    {
      title: "امکان پرداخت",
      text: "در اقساط 2 تا 6 ماه",
      icon: "./assets/img/theme/features/7.webp",
    },
    {
      title: "نگاه ۲ جانبه",
      text: "محیطی و ژنتیکی",
      icon: "./assets/img/theme/features/8.webp",
    },
    {
      title: "شیوه نمونه‌گیری",
      text: "از طریق بزاق دهان",
      icon: "./assets/img/theme/features/9.webp",
    },
    {
      title: "مطابق با",
      text: "آخرین پژوهش‌های روز دنیا",
      icon: "./assets/img/theme/features/10.webp",
    },
    {
      title: "مدت زمان جوابدهی",
      text: "3 ماه",
      icon: "./assets/img/theme/features/11.webp",
    },
    {
      title: "قابلیت انجام",
      text: "از بدو تولد",
      icon: "./assets/img/theme/features/12.webp",
    },
  ];
  constructor() {}

  ngOnInit() {
    this.features[1].text = this.arzyabi;
  }
}
